module.exports = __webpack_public_path__ + "img/4-4.bf5a086e.png";